import React from "react";
import { WHAT_IS_DTF, DTF_PROCESS } from "pages/dashboard/DtfInfoSection/data";
import {
  DtfInfoWrapper,
  WhatIsDtfSection,
  WhatIsDtfInner,
  WhatIsDtfTitle,
  WhatIsDtfDescription,
  DtfProcessSection,
  DtfProcessInner,
  ProcessHeader,
  ProcessTitle,
  ProcessDivider,
  ProcessSubtitle,
  ProcessSteps,
  ProcessStep,
  StepImageWrap,
  StepTitle,
  StepDescription,
} from "styles/pages/dashboard/dtfInfoSection";

const DtfInfoSection = () => (
  <DtfInfoWrapper>
    <WhatIsDtfSection>
      <WhatIsDtfInner>
        <WhatIsDtfTitle>{WHAT_IS_DTF.title}</WhatIsDtfTitle>
        <WhatIsDtfDescription>{WHAT_IS_DTF.description}</WhatIsDtfDescription>
      </WhatIsDtfInner>
    </WhatIsDtfSection>

    <DtfProcessSection>
      <DtfProcessInner>
        <ProcessHeader>
          <ProcessTitle>{DTF_PROCESS.title}</ProcessTitle>
          <ProcessDivider aria-hidden="true" />
          <ProcessSubtitle>{DTF_PROCESS.subtitle}</ProcessSubtitle>
        </ProcessHeader>

        <ProcessSteps>
          {DTF_PROCESS.steps.map((step, index) => (
            <ProcessStep key={step.title} $delay={index}>
              <StepImageWrap $animation={step.animation} $delay={index}>
                <img src={step.image} alt={step.alt} loading="lazy" />
              </StepImageWrap>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </ProcessStep>
          ))}
        </ProcessSteps>
      </DtfProcessInner>
    </DtfProcessSection>
  </DtfInfoWrapper>
);

export default DtfInfoSection;
